import type { Locale } from "./locales";

export * from "./locales";

export type TranslationResource = Record<string, string>;

// Lazy per-locale chunks. Pattern is relative to this file (src/lib/i18n).
// The value type carries `| undefined` on purpose: indexing a glob record with a
// locale that has no file is exactly the drift the guard below reports.
const localeLoaders = import.meta.glob("../../locales/*.json") as Record<
  string,
  (() => Promise<{ default: TranslationResource }>) | undefined
>;

// Throws rather than falling back to {} when a SUPPORTED_LOCALES entry has no
// file: a silent empty resource renders English everywhere and looks like a
// translation gap instead of the config/file drift it is.
export const loadLocaleResource = async (
  locale: Locale,
): Promise<TranslationResource> => {
  const loader = localeLoaders[`../../locales/${locale}.json`];
  if (!loader) throw new Error(`No translation file for locale "${locale}"`);
  const mod = await loader();
  return mod.default;
};
